import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import moment from 'moment';
import 'moment/locale/es-us';

import persistor, { store } from './store';
import Router from './router';
import SetupToken from './components/SetupToken';
import { NotificationProvider } from './components/NotificationAlerts';

moment.locale('es-us');

const App = () => (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <NotificationProvider>
        <SetupToken>
          <Router />
        </SetupToken>
      </NotificationProvider>
    </PersistGate>
  </Provider>
);

export default App;
